// extracted by mini-css-extract-plugin
export var cardSelected = "_hd-2";
export var image = "_hd-1";
export var table = "_hd-0";